<template>
  <div class="insight-item">
    <div class="unit-head">
      <el-popover :content="description" width="250" placement="bottom-end" trigger="hover">
        <h5 slot="reference" class="unit-title">{{ title }}</h5>
      </el-popover>
    </div>
    <div class="content">{{ Math.round(value).toLocaleString() }}</div>
  </div>
</template>

<script>
import IBox from '@/components/common/IBox';

export default {
  name: 'PostInsightItem',
  components: {
    IBox,
  },
  props: {
    description: {
      type: String,
      required: true,
      default: '',
    },
    value: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      required: true,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/style/_variables_live.scss';
$my-text-color: #676a6c;

.insight-item {
  text-align: center;
  padding: 13px;
  margin: 3px auto;
}

.unit-head {
  color: $my-text-color;

  .fa {
    font-size: 1.2em;
    margin-right: 0.8em;
  }
}

.reference {
  margin-left: 3px;
}

.unit-title {
  color: $colony-purple;
  display: inline;
  margin: 0 !important;
}

.content {
  color: $my-text-color;
  font-size: 2em;
}
</style>



// WEBPACK FOOTER //
// PostInsightItem.vue?2984f6eb